'use client';

import type { Opportunity } from '@/data/types';

interface OpportunitiesViewProps {
  opportunities: readonly Opportunity[];
  onShowToast: (message: string) => void;
}

export default function OpportunitiesView({
  opportunities,
  onShowToast,
}: OpportunitiesViewProps) {
  return (
    <div className="dashboard-view active">
      <h2 className="dash-heading">Today&#39;s Opportunities</h2>
      <p className="dash-subtext">
        Connections to introduce, events to recommend, and wins to celebrate.
        Each surfaced from member activity in the last 72 hours.
      </p>
      <div>
        {opportunities.map((opp, i) => (
          <div key={i} className="opp-card">
            <div className="opp-card-top">
              <span className={`opp-type ${opp.type}`}>{opp.typeName}</span>
              <span className="opp-when">{opp.when}</span>
            </div>
            <div className="opp-title">{opp.title}</div>
            <div className="opp-narrative">{opp.narrative}</div>
            <div className="opp-actions">
              <button
                className="opp-btn primary"
                onClick={() => onShowToast('Draft intro message created')}
              >
                Draft Intro
              </button>
              <button
                className="opp-btn secondary"
                onClick={() => onShowToast('Dismissed')}
              >
                Dismiss
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
